import { GAZE_METRICS_REPORT, MOBILITY_REPORT } from "../routes/routerPath";

const PUBLIC_REPORT_PREFIXES = [
  "/action-plan-report/",
  "/mobility-report-shared/",
];

export const isReportRoute = (pathname = "") =>
  pathname === MOBILITY_REPORT ||
  pathname === GAZE_METRICS_REPORT ||
  PUBLIC_REPORT_PREFIXES.some((prefix) => pathname.startsWith(prefix));

export const isRestorableAppUrl = (url = "") => {
  if (typeof url !== "string" || !url.startsWith("/") || url.startsWith("//")) {
    return false;
  }
  const pathname = url.split(/[?#]/, 1)[0];
  return !isReportRoute(pathname);
};
